<template>
  <div class="hello">
    <div class="main-bg">
      <img v-for="(img, i) in carouselImages" :key="i" :src="img" class="carousel-img" :class="{ active: currentSlide === i }" alt="">
    </div>
    <div class="top">
      <img class="logo" src="../assets/imgs/logo@2x.png" alt="">
      <div class="language">
        <div class="lang-switch" @click="toggleLang">
          <span>{{ currentLang === 'zh' ? '中文' : 'English' }}</span>
          <span class="arrow"></span>
          <ul v-show="showDropdown" class="lang-dropdown">
            <li @click.stop="switchLang('zh')">中文</li>
            <li @click.stop="switchLang('en')">English</li>
          </ul>
        </div>
        <span class="divider"></span>
        <img class="search-icon" src="../assets/imgs/图层 925@2x.png" alt="" @click="showSearch = !showSearch">
        <div v-if="showSearch" class="search-bar">
          <input v-model="searchText" type="text" class="search-input" placeholder="Search..." @keydown.enter="doSearch">
          <span class="search-btn" @click="doSearch">Search</span>
        </div>
      </div>
      <div class="weather top-item">
        <img src="../assets/imgs/组 18@2x.png" alt="">
        <div class="info">
          <div class="main-info">
            <div class="status">{{ weatherIcon }}</div>
            <div class="label">{{ weather.temperature }}°</div>
          </div>
          <div class="desc-info">Weather</div>
        </div>
      </div>
      <div class="time top-item">
        <img src="../assets/imgs/组 18@2x (3).png" alt="">
        <div class="info">
          <div class="main-info">Dynamic tourist volume</div>
          <div class="desc-info marquee-wrap">
            <span class="marquee-text">{{ siteConfig.visitorInfo || 'Max capacity: 81,000 | Current: 2,688 | Comfort: 5' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="main-contain">
      <div class="menu">
        <div v-for="(item, index) in menuList" :key="index"
          class="menu-item" :class="{ active: activeMenu === index }"
          @click="selectMenu(index)">{{ item }}</div>
      </div>
      <SearchSection v-if="enSearching" :initial-query="enSearchQuery" lang="en" @go-home="enSearching = false" />
      <template v-else>
      <template v-if="enArticleItem">
        <div class="en-article-detail">
          <div class="breadcrumb">
            <span>Current Location:
              <span class="breadcrumb-link" @click="goEnHome">Home</span>
              <span v-if="enArticleMenu"> / <span class="breadcrumb-link" @click="backToMenu">{{ enArticleMenu }}</span></span>
              <span v-if="enArticleCategory"> / <span class="breadcrumb-link" @click="backToCategory">{{ enArticleCategory }}</span></span>
              <span> / Article Detail</span>
            </span>
          </div>
          <div class="article-content">
            <h2>{{ enArticleItem.title }}</h2>
            <p class="article-date">{{ enArticleItem.date }}</p>
            <img v-if="enArticleItem.img && !enArticleItem.content" :src="enArticleItem.img" alt="" class="article-img">
            <div v-if="enArticleItem.content" v-html="enArticleItem.content" class="article-desc"></div>
            <p v-else class="article-desc">{{ enArticleItem.desc }}</p>
            <div v-if="enNextArticle" class="next-article" @click="enGoNextArticle">
              Next：{{ enNextArticle.title }}
            </div>
            <div v-else class="next-article no-more">No more articles</div>
          </div>
        </div>
      </template>
      <template v-else>
      <template v-if="activeMenu === 0">
        <div class="en-home">
          <div class="section-1">
            <div class="video-wrap">
              <video v-if="siteConfig.homepage_video" :src="siteConfig.homepage_video" class="video-player" controls></video>
              <div v-else class="video-placeholder">
                <span class="play-icon">▶</span>
              </div>
            </div>
            <div class="intro-wrap">
              <div class="section-header" @click="activeMenu = 1">
                <div class="section-title">Scenic Spot Overview</div>
              </div>
              <div class="intro-content">
                <p>{{ overviewSummary }}<span class="more-link" @click="activeMenu = 1">more>></span></p>
              </div>
          </div>
        </div>
        <div class="en-nav-icons">
          <div
            v-for="(item, index) in enIconList"
            :key="index"
            class="nav-item"
            :class="{ active: enSelectedIcon === index }"
            @click="selectEnIcon(index)"
          >
            <img :src="item.img" alt="" class="nav-img">
            <span class="nav-text" :style="{ color: item.color }">{{ item.label }}</span>
          </div>
        </div>
        <div class="section-2">
          <div class="title-wrap">
            <div class="section-title">Cultural Huaguo Mountain</div>
          </div>
          <div class="culture-slider-wrap">
            <div class="culture-arrow culture-arrow-left" @click="cultureScrollIndex = Math.max(0, cultureScrollIndex - 1)" :class="{ disabled: cultureScrollIndex === 0 }">&#8249;</div>
            <div class="culture-slider">
              <div class="culture-track" :style="{ transform: 'translateX(-' + cultureScrollIndex * 25 + '%)' }">
                <div v-for="(item, index) in cultureList" :key="index" class="culture-item" @click="openEnArticle(item)">
                  <img :src="item.img" alt="" class="culture-img">
                  <div class="culture-label" :style="{ backgroundImage: 'url(' + item.bgImg + ')' }">{{ item.title }}</div>
                </div>
              </div>
            </div>
            <div class="culture-arrow culture-arrow-right" @click="cultureScrollIndex = Math.min(cultureList.length - 4, cultureScrollIndex + 1)" :class="{ disabled: cultureScrollIndex >= cultureList.length - 4 }">&#8250;</div>
          </div>
        </div>
        <div class="section-3">
          <div class="title-wrap">
            <div class="section-title">Scenic Area Scenery</div>
          </div>
          <div class="gallery-grid">
            <div
              v-for="item in enSceneList"
              :key="item.id"
              class="gallery-item"
              :style="getEnGridStyle(item)"
              @click="previewImage = item.imageUrl || item.img"
            >
              <img :src="item.img || thumbImg" :alt="item.title">
              <div class="gallery-title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
      </template>
      <template v-if="activeMenu === 1">
        <div class="en-about" :style="{ backgroundImage: 'url(' + msgBack + ')' }">
          <div class="breadcrumb">
            <span>Current Location:
              <span class="breadcrumb-link" @click="activeMenu = 0">Home</span>
              <span> / </span>
              <span>About Huaguo Mountain</span>
            </span>
          </div>
          <div class="about-title">Scenic Spot Overview</div>
          <div class="about-content" v-html="aboutContent"></div>
        </div>
      </template>
      <template v-if="activeMenu === 2">
        <div class="en-scenery">
          <div class="breadcrumb">
            <span>Current Location:
              <span class="breadcrumb-link" @click="activeMenu = 0">Home</span>
              <span> / </span>
              <span>Scenery Of The Area</span>
            </span>
          </div>
          <div class="nav-icons">
            <div
            v-for="(item, index) in enIconList"
            :key="index"
            class="nav-item"
            :class="{ active: enSelectedIcon === index }"
            @click="selectEnIcon(index)"
          >
            <img :src="item.img" alt="" class="nav-img">
            <span class="nav-text" :style="{ color: item.color }">{{ item.label }}</span>
            <div v-if="enSelectedIcon === index" class="nav-arrow" :style="{ borderBottomColor: item.color }"></div>
            </div>
          </div>
          <div v-if="enSelectedIcon >= 0 && enSelectedIcon !== 2" class="content-grid">
            <div
              v-for="(item, index) in enContentList"
              :key="index"
              class="grid-item"
               @click="openEnArticle(item, 'Scenery Of The Area', enCurrentCategory, 2, enSelectedIcon)"
            >
              <img :src="item.img" alt="" class="grid-img">
              <div class="grid-title">
                <span class="title-line" :style="{ background: currentColor }"></span>
                {{ item.title }}
              </div>
              <div class="grid-desc">{{ item.desc }}</div>
            </div>
          </div>
          <div v-if="enSelectedIcon >= 0 && enSelectedIcon !== 2 && enCategoryTotalPages > 1" class="pagination">
            <span class="page-btn" @click="enCategoryGoFirst">First</span>
            <span class="page-btn" @click="enCategoryGoPrev">Prev</span>
            <template v-for="(n, i) in enCategoryPageNumbers" :key="i">
              <span v-if="n === '...'" class="page-ellipsis">...</span>
              <span v-else class="page-num" :class="{ active: enCategoryPage === n }" @click="enCategoryGoPage(n)">{{ n }}</span>
            </template>
            <span class="page-btn" @click="enCategoryGoNext">Next</span>
            <span class="page-btn" @click="enCategoryGoLast">Last</span>
          </div>
          <div v-if="enSelectedIcon === 2" class="location-content">
            <div class="location-info">
              <div class="info-item">
                <img :src="locationImg" alt="" class="info-icon">
                <span>Address: No. 5 Yulin Road, Haizhou District, Lianyungang City</span>
              </div>
              <div class="info-item">
                <img :src="clockImg" alt="" class="info-icon">
                <span>Opening hours: {{ siteConfig.openTime || '07:00-18:00' }}</span>
              </div>
              <div class="info-item">
                <img :src="phoneImg" alt="" class="info-icon">
                <span>Official phone number: {{ siteConfig.contactPhone || '0518-85723839' }}</span>
              </div>
            </div>
            <div class="map-wrap">
              <div id="enHgsMap" class="map-img"></div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="activeMenu === 3">
        <div class="en-service">
          <div class="breadcrumb">
            <span>Current Location:
              <span class="breadcrumb-link" @click="activeMenu = 0">Home</span>
              <span> / </span>
              <span>Consultation Service</span>
            </span>
          </div>
          <div class="service-title">Consultation Service</div>
          <div class="service-form">
            <div class="form-item">
              <label class="form-label">Contact</label>
              <input v-model="serviceForm.contact" type="text" class="form-input" placeholder="Please enter your name">
            </div>
            <div class="form-item">
              <label class="form-label">Contact phone number</label>
              <input v-model="serviceForm.phone" type="text" class="form-input" placeholder="Please enter your phone number">
            </div>
            <div class="form-item">
              <label class="form-label">Issue Description</label>
              <textarea v-model="serviceForm.description" class="form-textarea" placeholder="Please describe your issue"></textarea>
            </div>
            <div class="form-item">
              <label class="form-label">Photo Upload</label>
              <div class="upload-area">
                <input type="file" class="upload-input" id="fileUpload" @change="onFileChange">
                <label for="fileUpload" class="upload-label">Choose File</label>
                <span v-if="serviceForm.fileName" class="file-name">{{ serviceForm.fileName }}</span>
              </div>
            </div>
            <div class="form-submit" @click="submitService">Thanks for submission</div>
          </div>
        </div>
      </template>
      <template v-if="activeMenu === 5">
        <div class="en-vr">
          <h2>Virtual Tour</h2>
          <p>Experience a 360° panoramic virtual tour of Huaguo Mountain from the comfort of your home.</p>
        </div>
      </template>
      </template>
      </template>
    </div>
  </div>
  <div v-if="previewImage" class="preview-overlay" @click="previewImage = null">
    <img :src="previewImage" alt="" class="preview-img">
    <span class="preview-close" @click.stop="previewImage = null">×</span>
  </div>
</template>

<script>
import img1 from '../assets/imgs/大图1.png'
import img2 from '../assets/imgs/大图2.png'
import img3 from '../assets/imgs/大图3.png'
import img4 from '../assets/imgs/大图4.png'
import icon1 from '../assets/imgs/1.png'
import icon2 from '../assets/imgs/2.png'
import icon3 from '../assets/imgs/3.png'
import icon4 from '../assets/imgs/4.png'
import icon5 from '../assets/imgs/5.png'
import icon6 from '../assets/imgs/6.png'
import cultureImg from '../assets/imgs/4834c0ae-e705-4aa4-8a18-9fc191e261ff.png'
import thumbImg from '../assets/imgs/ceshi.png'
import msgBack from '../assets/imgs/msgBack.cc9c9f44.png'
import bg1 from '../assets/imgs/11.png'
import bg2 from '../assets/imgs/12.png'
import bg3 from '../assets/imgs/13.png'
import bg4 from '../assets/imgs/14.png'
import locationImg from '../assets/imgs/location.png'
import clockImg from '../assets/imgs/clock.png'
import phoneImg from '../assets/imgs/phone.png'
import { getConfig, getWeather, getArticles, getArticleDetail, getFaq, submitMessage, getGallery, getPrevNext, getMapKey } from '../api/index'
import SearchSection from './SearchSection.vue'

export default {
  name: 'HomeEnglish',
  components: { SearchSection },
  emits: ['switch-language'],
  data() {
    return {
      currentLang: 'en',
      showDropdown: false,
      activeMenu: 0,
      siteConfig: {},
      weather: { weather: 'Sunny', temperature: '12°~20°' },
      locationImg,
      clockImg,
      phoneImg,
      cultureScrollIndex: 0,
      enArticleItem: null,
      enArticleMenu: '',
      enArticleMenuIndex: 0,
      enArticleCategory: '',
      enArticleIconIndex: 0,
      enNextArticle: null,
      cultureList: [],
      overviewSummary: '',
      aboutContent: '',
      showFullOverview: false,
      msgBack,
      serviceForm: {
        contact: '',
        phone: '',
        description: '',
        fileName: '',
      },
      showSearch: false,
      searchText: '',
      previewImage: null,
      enSearching: false,
      enSearchQuery: '',
      enCategoryPage: 1,
      enCategoryTotal: 0,
      enMessages: [{
        type: 'ai',
        text: 'Hello, I am Sun Xiaokong, how can I help you?',
        welcome: true,
        options: ['How to buy tickets?', 'Where to take the shuttle bus?'],
      }],
      enInputText: '',
      enTyping: false,
      enQuickTips: ['Tickets', 'Opening Hours', 'Transportation', 'Attractions', 'Cable Car', 'Parking', 'Hotels', 'Weather'],
      menuList: ['Home', 'About', 'Scenery Of The Area', 'Consultation Service', 'Audio Guide', 'Virtual Tour'],
      carouselImages: [img1, img2, img3, img4],
      currentSlide: 0,
      enSelectedIcon: 0,
      enIconList: [
        { img: icon1, label: 'Food', color: '#E74A08' },
        { img: icon2, label: 'Hotel', color: '#1A94D3' },
        { img: icon3, label: 'Itinerary', color: '#3BAC74' },
        { img: icon4, label: 'Transportation', color: '#16A39E' },
        { img: icon5, label: 'Shopping', color: '#DB7625' },
        { img: icon6, label: 'Entertainment', color: '#16A39E' },
      ],
      enAllContents: [[], [], [], [], [], []],
      enMap: null,
      enSceneList: [],
    }
  },
  computed: {
    weatherIcon() {
      const w = this.weather.weather || ''
      if (w.includes('雨')) return '🌧'
      if (w.includes('雪')) return '❄'
      if (w.includes('云') || w.includes('阴')) return '⛅'
      if (w.includes('雾') || w.includes('霾')) return '🌫'
      return '☀'
    },
    enContentList() {
      return this.enAllContents[this.enSelectedIcon] || []
    },
    currentColor() {
      const item = this.enIconList[this.enSelectedIcon]
      return item ? item.color : '#000'
    },
    enCurrentCategory() {
      return this.enIconList[this.enSelectedIcon]?.label || ''
    },
    enCategoryTotalPages() {
      return Math.max(1, Math.ceil(this.enCategoryTotal / 9))
    },
    enCategoryPageNumbers() {
      const total = this.enCategoryTotalPages
      const cur = this.enCategoryPage
      if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
      const pages = [1, 2]
      if (cur > 3) pages.push('...')
      if (cur > 2 && cur < total - 1) pages.push(cur)
      if (cur < total - 2) pages.push('...')
      pages.push(total - 1, total)
      return [...new Set(pages)]
    },
  },
   watch: {
    activeMenu(val) {
      if (val === 1 && !this.aboutContent) this.fetchAboutContent()
      if (val === 2) this.fetchEnCategory()
    },
    enSelectedIcon() {
      if (this.activeMenu === 2) {
        this.enCategoryPage = 1
        this.fetchEnCategory()
        if (this.enSelectedIcon === 2) this.$nextTick(() => this.initEnMap())
      }
    },
    '$route.query.menu': function(val) {
      const idx = val === undefined ? 0 : parseInt(val)
      if (!isNaN(idx) && idx !== this.activeMenu && idx >= 0 && idx <= 5) {
        this.activeMenu = idx
        this.enArticleItem = null
        this.enSearching = false
      }
    },
    '$route.query.enIcon': function(val) {
      const idx = parseInt(val)
      if (!isNaN(idx) && idx >= 0 && idx <= 5 && idx !== this.enSelectedIcon) {
        this.enSelectedIcon = idx
      }
    },
    '$route.query.enArticle': function(val) {
      if (!val) this.enArticleItem = null
    },
  },
  mounted() {
    const m = parseInt(this.$route.query.menu)
    if (!isNaN(m) && m >= 0 && m <= 5 && m !== this.activeMenu) {
      this.activeMenu = m
    }
    const ei = parseInt(this.$route.query.enIcon)
    if (!isNaN(ei) && ei >= 0 && ei <= 5) {
      this.enSelectedIcon = ei
    }
    if (this.$route.query.enArticle) {
      var articleId = this.$route.query.enArticle
      this.enArticleItem = { id: articleId }
      this.$nextTick(function() {
        getArticleDetail(articleId).then(function(res) {
          if (res.code === 200 && res.data) {
            this.enArticleItem = {
              id: articleId,
              title: res.data.title || '',
              date: (res.data.publishTime || '').substring(0, 10),
              img: res.data.coverImage || '',
              desc: res.data.summary || '',
              content: res.data.content || '',
            }
            getPrevNext(articleId, { category: res.data.category, lang: 'en' }).then(function(pn) {
              if (pn.code === 200 && pn.data) { this.enNextArticle = pn.data.next }
            }.bind(this))
          }
        }.bind(this))
      })
    }
    this.fetchSiteConfig()
    this.fetchWeather()
    this.fetchCultureData()
    this.fetchOverview()
    this.fetchEnGallery()
    this.timer = setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % this.carouselImages.length
    }, 3000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async fetchEnGallery() {
      try {
        const res = await getGallery('en')
        if (res.code === 200 && res.data) {
          this.enSceneList = res.data.map(item => ({
            id: item.articleId,
            title: item.title,
            img: item.thumbnailUrl || item.imageUrl,
            imageUrl: item.imageUrl,
            articleId: item.articleId,
            gridRowStart: item.gridRowStart,
            gridRowSpan: item.gridRowSpan,
            gridColumnStart: item.gridColumnStart,
            gridColumnSpan: item.gridColumnSpan,
          }))
        }
      } catch (e) {
        console.error('fetchEnGallery failed:', e)
      }
    },
    getEnGridStyle(item) {
      const style = {}
      if (item.gridRowStart) style.gridRowStart = item.gridRowStart
      if (item.gridRowSpan) style.gridRow = `span ${item.gridRowSpan}`
      if (item.gridColumnStart) style.gridColumnStart = item.gridColumnStart
      if (item.gridColumnSpan) style.gridColumn = `span ${item.gridColumnSpan}`
      return style
    },
    async fetchWeather() {
      try {
        const res = await getWeather()
        if (res.code === 200 && res.data && res.data.lives && res.data.lives.length) {
          const live = res.data.lives[0]
          this.weather = {
            weather: live.weather,
            temperature: live.temperature,
          }
        }
      } catch (e) {
        console.error('getWeather failed:', e)
      }
    },
    async fetchEnCategory() {
      const categoryMap = ['travel_food', 'travel_accommodation', null, 'travel_activities', 'travel_specialties', 'travel_entertainment']
      const category = categoryMap[this.enSelectedIcon]
      if (!category) return
      try {
        const res = await getArticles({ category, lang: 'en', pageNum: this.enCategoryPage, pageSize: 9 })
        this.enCategoryTotal = res.total || 0
        const iconImgs = [icon1, icon2, icon3, icon4, icon5, icon6]
        const iconImg = iconImgs[this.enSelectedIcon] || icon1
        const list = (res.rows || []).map(item => ({
          id: item.id,
          img: item.coverImage || iconImg,
          title: item.title,
          desc: item.summary || '',
          date: (item.publishTime || '').substring(0, 10),
        }))
        this.enAllContents.splice(this.enSelectedIcon, 1, list)
      } catch (e) {
        console.error('fetchEnCategory failed:', e)
      }
    },
    async fetchAboutContent() {
      try {
        const listRes = await getArticles({ category: 'overview', lang: 'en', pageSize: 1 })
        const items = listRes.rows || []
        if (!items.length) return
        const detailRes = await getArticleDetail(items[0].id)
        if (detailRes.code === 200 && detailRes.data) {
          this.aboutContent = detailRes.data.content || ''
        }
      } catch (e) {
        console.error('fetchAboutContent failed:', e)
      }
    },
    async fetchOverview() {
      try {
        const listRes = await getArticles({ category: 'overview', lang: 'en', pageSize: 1 })
        const items = listRes.rows || []
        if (!items.length) return
        const detailRes = await getArticleDetail(items[0].id)
        if (detailRes.code === 200 && detailRes.data) {
          this.overviewSummary = detailRes.data.summary || ''
        }
      } catch (e) {
        console.error('fetchOverview failed:', e)
      }
    },
    async fetchCultureData() {
      try {
        const res = await getArticles({ category: 'culture', lang: 'en', pageNum: 1, pageSize: 99 })
        const items = res.rows || []
        const bgImgs = [bg1, bg2, bg3, bg4]
        this.cultureList = items.map((item, i) => ({
          id: item.id,
          img: item.coverImage || cultureImg,
          title: item.title,
          bgImg: bgImgs[i % bgImgs.length],
          date: (item.publishTime || '').substring(0, 10),
          desc: item.summary || '',
        }))
      } catch (e) {
        console.error('fetchCultureData failed:', e)
      }
    },
    async fetchSiteConfig() {
      try {
        const res = await getConfig()
        if (res.code === 200 && res.data) {
          this.siteConfig = res.data
        }
      } catch (e) {
        console.error('getConfig failed:', e)
      }
    },
    toggleLang() {
      this.showDropdown = !this.showDropdown
    },
    switchLang(lang) {
      if (lang !== this.currentLang) {
        if (lang === 'zh') {
          localStorage.setItem('hgs_lang', 'zh')
          window.location.href = window.location.origin + '/?menu=0'
        } else {
          this.$emit('switch-language', lang)
        }
      }
    },
    selectMenu(index) {
      if (index === 4) {
        window.open('/#/audio-guide', '_blank')
        return
      }
      if (index === 5) {
        const url = this.siteConfig.vr_tour_url || this.siteConfig.vrTourUrl
        if (url) window.open(url, '_blank')
        return
      }
      this.activeMenu = index
      this.enArticleItem = null
      this.enSearching = false
      var q = { menu: index }
      if (index === 2) q.enIcon = this.enSelectedIcon
      this.$router.push({ query: q }).catch(() => {})
      this.$nextTick(() => { window.scrollTo(0, 0) })
    },
    selectEnIcon(index) {
      this.activeMenu = 2
      this.enSelectedIcon = index
      this.enArticleItem = null
      this.$router.replace({ query: { menu: 2, enIcon: index } }).catch(() => {})
    },
    async openEnArticle(item, menu, category, menuIndex, iconIndex) {
      this.enArticleItem = { ...item }
      this.enNextArticle = null
      this.enArticleMenu = menu || ''
      this.enArticleMenuIndex = menuIndex !== undefined ? menuIndex : this.activeMenu
      this.enArticleCategory = category || ''
      this.enArticleIconIndex = iconIndex !== undefined ? iconIndex : this.enSelectedIcon
      this.$router.push({ query: { menu: this.activeMenu, enIcon: this.enSelectedIcon, enArticle: item.id } }).catch(() => {})
      this.$nextTick(() => { window.scrollTo(0, 0) })
      if (item.id) {
        try {
          const res = await getArticleDetail(item.id)
          if (res.code === 200 && res.data) {
            this.enArticleItem = { ...item, ...res.data }
            const pn = await getPrevNext(item.id, { category: res.data.category, lang: 'en' })
            if (pn.code === 200 && pn.data) this.enNextArticle = pn.data.next
          }
        } catch (e) {
          console.error('getArticleDetail failed:', e)
        }
      }
    },
    enGoNextArticle() {
      if (this.enNextArticle) {
        const next = this.enNextArticle
        this.openEnArticle(next)
      }
    },
    enCategoryGoPage(n) { if (this.enCategoryPage !== n) { this.enCategoryPage = n; this.fetchEnCategory() } },
    enCategoryGoFirst() { if (this.enCategoryPage !== 1) { this.enCategoryPage = 1; this.fetchEnCategory() } },
    enCategoryGoPrev() { if (this.enCategoryPage > 1) { this.enCategoryPage--; this.fetchEnCategory() } },
    enCategoryGoNext() { if (this.enCategoryPage < this.enCategoryTotalPages) { this.enCategoryPage++; this.fetchEnCategory() } },
    enCategoryGoLast() { if (this.enCategoryPage !== this.enCategoryTotalPages) { this.enCategoryPage = this.enCategoryTotalPages; this.fetchEnCategory() } },
    async initEnMap() {
      if (this.enMap) return
      try {
        const keyRes = await getMapKey()
        const KEY = (keyRes.code === 200 && keyRes.msg) ? keyRes.msg : ''
        if (!KEY) return
        const loadMap = () => {
          this.$nextTick(() => {
            const el = document.getElementById('enHgsMap')
            if (!el || el.innerHTML) return
            const center = new window.TMap.LatLng(34.632, 119.283)
            this.enMap = new window.TMap.Map(el, { center, zoom: 14 })
            new window.TMap.MultiMarker({
              map: this.enMap,
              geometries: [{ id: 'hgs', position: center }],
            })
          })
        }
        if (window.TMap) { loadMap(); return }
        const script = document.createElement('script')
        script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${KEY}`
        script.onload = () => setTimeout(loadMap, 300)
        document.head.appendChild(script)
      } catch (e) {
        console.error('map load failed:', e)
      }
    },
    goEnHome() {
      this.enArticleItem = null
      this.activeMenu = 0
      this.$router.replace({ query: { menu: 0 } }).catch(() => {})
    },
    backToMenu() {
      this.activeMenu = this.enArticleMenuIndex
      this.enArticleItem = null
      this.$router.replace({ query: { menu: this.enArticleMenuIndex } }).catch(() => {})
    },
    enGoNextArticle() {
      if (this.enNextArticle) {
        const next = this.enNextArticle
        this.openEnArticle(next)
      }
    },
    backToCategory() {
      this.activeMenu = this.enArticleMenuIndex
      this.enSelectedIcon = this.enArticleIconIndex
      this.enArticleItem = null
      this.$router.replace({ query: { menu: this.enArticleMenuIndex, enIcon: this.enArticleIconIndex } }).catch(() => {})
    },
    onFileChange(e) {
      const file = e.target.files[0]
      if (file) this.serviceForm.fileName = file.name
    },
    doSearch() {
      const q = this.searchText.trim()
      if (q) {
        this.enSearchQuery = q
        this.enSearching = true
        this.showSearch = false
        this.searchText = ''
      }
    },
    async submitService() {
      if (!this.serviceForm.description.trim()) {
        alert('Please enter your issue description')
        return
      }
      try {
        const res = await submitMessage({
          type: 'leave_word',
          name: this.serviceForm.contact,
          phone: this.serviceForm.phone,
          content: this.serviceForm.description,
        })
        if (res.code === 200) {
          alert('Thanks for submission')
          this.serviceForm = { contact: '', phone: '', description: '', fileName: '' }
        } else {
          alert(res.msg || 'Submission failed, please try again later')
        }
      } catch (e) {
        alert('Submission failed, please try again later')
      }
    },
  },
}
</script>

<style scoped lang="less">
.preview-overlay{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.85);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .preview-img{
    max-width: 90vw;
    max-height: 90vh;
    object-fit: contain;
  }
  .preview-close{
    position: absolute;
    top: 0.3rem;
    right: 0.5rem;
    font-size: 0.6rem;
    color: #fff;
    cursor: pointer;
    &:hover{ opacity: 0.7; }
  }
}
.hello{
  background-color: #E7EFF6;
  padding-bottom: 0.6rem;
  position: relative;
  border-top: 1px solid transparent;
    .main-bg{
      width: 100vw;
      height: 7.83rem;
      position: absolute;
      left: 0;
    z-index: 0;
    overflow: hidden;
    .carousel-img{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 0.8s ease;
      &.active{ opacity: 1; }
    }
  }
    .top{
      width: 100%;
      height: 1.11rem;
      background-color: rgba(0, 0, 0, .4);
      padding: 0 0 0 3.4rem;
      display: flex;
      align-items: center;
      position: absolute;
      z-index: 9;
      .logo{
        width: 2.17rem;
        height: auto;
      }
      .language{
        position: relative;
        display: flex;
        align-items: center;
        margin-left: .52rem;
        margin-right: .8rem;
        .divider{
          display: inline-block;
          width: 1px;
          height: 0.19rem;
          background: rgba(255,255,255,.3);
          margin: 0 0.2rem;
        }
        .search-icon{
          width: .25rem;
          height: auto;
          cursor: pointer;
        }
        .lang-switch{
          position: relative;
          color: #F9F8F7;
          font-size: .225rem;
          cursor: pointer;
          user-select: none;
          .arrow{
            display: inline-block;
            width: 0;
            height: 0;
            margin-left: 0.1rem;
            border-left: 0.06rem solid transparent;
            border-right: 0.06rem solid transparent;
            border-top: 0.08rem solid #fff;
            vertical-align: middle;
          }
          .lang-dropdown{
            position: absolute;
            top: 100%;
            right: 0;
            background: #fff;
            color: #333;
            list-style: none;
            padding: 0.1rem 0;
            margin: 0.1rem 0 0;
            border-radius: 0.1rem;
            min-width: 1.6rem;
            box-shadow: 0 0.1rem 0.3rem rgba(0,0,0,.2);
            li{
              padding: 0.15rem 0.4rem;
              cursor: pointer;
              &:hover{
                background: #f0f0f0;
              }
            }
          }
        }
      }
      .top-item{
        color: #fff;
        display: flex;
        margin-left: .3125rem;
        img{
          width: 0.53rem;
          height: auto;
        }
        .info{
          margin-left: 0.13rem;
          .main-info{
            font-size: 0.22rem;
          }
          .desc-info{
            font-size: 0.13rem;
            margin-top: 0.02rem;

        }
      }
      }
      .weather{
        .main-info{
          display: flex;
          align-items: center;
          .weather-icon{
            width: 0.23rem;
            height: 0.22rem;
            margin: 0 0.02rem;
          }
        }
      }

  }
  .search-bar{
    position: absolute;
    right: -2rem;
    bottom: -1.04rem;
    z-index: 10;
    display: flex;
    background: #fff;
    border-radius: 0.06rem;
    box-shadow: 0 0.04rem 0.12rem rgba(0,0,0,.15);
    padding: 0.1rem;
    .search-input{
      width: 3rem;
      height: 0.45rem;
      border: 1px solid #ccc;
      border-radius: 0.04rem;
      padding: 0 0.1rem;
      font-size: 0.18rem;
      outline: none;
      &:focus{ border-color: #369BF8; }
    }
    .search-btn{
      width: 0.7rem;
      text-align: center;
      height: 0.45rem;
      line-height: 0.45rem;
      background: #369BF8;
      color: #fff;
      border-radius: 0.04rem;
      margin-left: 0.1rem;
      font-size: 0.16rem;
      cursor: pointer;
      &:hover{ background: #1372C9; }
    }
  }
  .main-contain{
    width: 14.95rem;
    padding: 0.14rem;
    background-color: #fff;
    margin: 0 auto;
    margin-top: 5.7rem;
    position: relative;
    z-index: 1;
    .menu{
      display: table;
      width: 100%;
      .menu-item{
        display: table-cell;
        height: 0.78rem;
        line-height: 0.78rem;
        text-align: center;
        font-size: 0.32rem;
        padding: 0 0.3rem;
        color: #FAF9F8;
        background: #369BF8;
        cursor: pointer;
        border-right: 1px solid #1372C9;
        white-space: nowrap;
        &:last-child{
          border-right: none;
        }
        &.active{
          background: #1372C9;
        }
      }
    }
    .en-home{
      padding: 0.2rem 0;
      .section-1{
        height: 3.77rem;
        display: flex;
        gap: 0.2rem;
        .video-wrap{
          flex: 1;
          .video-player{
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .video-placeholder{
            width: 100%;
            height: 100%;
            background: #000;
            display: flex;
            align-items: center;
            justify-content: center;
            .play-icon{
              font-size: 0.6rem;
              color: #fff;
              cursor: pointer;
            }
          }
        }
        .intro-wrap{
          flex: 1;
          min-width: 0;
          .section-header{
            height: 0.6rem;
            background: rgba(0,0,0,.05);
            display: flex;
            align-items: center;
            cursor: pointer;
            .section-title{
              height: 0.6rem;
              width: 3.6rem;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.24rem;
              color: #fff;
              background: #369BF8;
            }
          }
          .intro-content{
            margin-top: 0.1rem;
            p{
              font-size: 0.2rem;
              color: #4F4E4E;
              line-height: 0.33rem;
              text-indent: 2em;
              margin: 0 0 0.08rem;
              .more-link{
                color: #369BF8;
                font-size: 0.18rem;
                cursor: pointer;
                user-select: none;
              }
            }
          }
        }
      }
      .en-nav-icons{
        display: flex;
        justify-content: center;
        gap: 0.3rem;
        padding: 0.3rem 0;
        background: url('../assets/imgs/图层 1054.png') no-repeat center / cover;
        margin-top: 0.2rem;
        .nav-item{
          position: relative;
          cursor: pointer;
          .nav-img{
            width: 2rem;
            height: 2.16rem;
            display: block;
          }
          .nav-text{
            position: absolute;
            left: 50%;
            bottom: 0.26rem;
            transform: translateX(-50%);
            font-size: 0.2rem;
            white-space: nowrap;
          }
        }
      }
      .section-2{
        margin-top: 0.3rem;
        .title-wrap{
          border-bottom: 1px solid #e0e0e0;
          margin-bottom: 0.25rem;
          display: flex;
          align-items: center;
          .section-title{
            display: inline-block;
            font-size: 0.27rem;
            color: #115DB2;
            border-bottom: 2px solid #115DB2;
            padding-bottom: 0.02rem;
            margin-bottom: -1px;
          }
          .more-btn{
            margin-left: auto;
            font-size: 0.16rem;
            color: #115DB2;
            cursor: pointer;
            &:hover{ color: #369BF8; }
          }
        }
        .culture-slider-wrap{
          display: flex;
          align-items: center;
          gap: 0.1rem;
          margin-top: 0.1rem;
          .culture-arrow{
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 50%;
            background: #369BF8;
            color: #fff;
            font-size: 0.24rem;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            flex-shrink: 0;
            user-select: none;
            transition: opacity 0.2s;
            &:hover{ opacity: 0.8; }
            &.disabled{
              opacity: 0.3;
              cursor: default;
            }
          }
          .culture-slider{
            flex: 1;
            overflow: hidden;
            .culture-track{
              display: flex;
              transition: transform 0.4s ease;
              .culture-item{
                width: calc((100% - 0.6rem) / 4);
                flex-shrink: 0;
                margin-right: 0.2rem;
                cursor: pointer;
                &:last-child{ margin-right: 0; }
                .culture-img{
                  width: 100%;
                  height: 2.6rem;
                  object-fit: cover;
                  display: block;
                }
                .culture-label{
                  height: 0.5rem;
                  line-height: 0.5rem;
                  text-align: center;
                  font-size: 0.2rem;
                  color: #fff;
                  background-size: cover;
                  background-position: center;
                  padding: 0 0.1rem;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }
      .section-3{
        margin-top: 0.5rem;
        .title-wrap{
          border-bottom: 1px solid #e0e0e0;
          margin-bottom: 0.25rem;
          display: flex;
          align-items: center;
          .section-title{
            display: inline-block;
            font-size: 0.27rem;
            color: #115DB2;
            border-bottom: 2px solid #115DB2;
            padding-bottom: 0.02rem;
            margin-bottom: -1px;
          }
        }
        .gallery-grid{
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          grid-auto-rows: 250px;
          grid-auto-flow: dense;
          gap: 8px;
          .gallery-item{
            position: relative;
            overflow: hidden;
            cursor: pointer;
            border-radius: 4px;
            img{
              width: 100%;
              height: 100%;
              object-fit: cover;
              display: block;
              transition: transform 0.3s;
            }
            &:hover img{ transform: scale(1.05); }
            .gallery-title{
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              padding: 8px 16px;
              background: linear-gradient(transparent, rgba(0,0,0,0.6));
              color: #fff;
              font-size: 14px;
              text-align: center;
            }
          }
        }
      }
    }
    .en-article-detail{
      padding: 0.2rem 0.1rem;
      .breadcrumb{
        font-size: 0.2rem;
        color: #666;
        padding-bottom: 0.2rem;
        .breadcrumb-link{
          cursor: pointer;
          &:hover{ color: #369BF8; }
        }
      }
        .article-content{
        padding: 0 0.5rem;
          background: #fff;
          border-radius: 0.1rem;
          img{ max-width: 10rem; }
          .next-article{
            margin-top: 0.4rem;
            font-size: 0.2rem;
            color: #369BF8;
            cursor: pointer;
            &:hover{ text-decoration: underline; }
            &.no-more{ color: #999; cursor: default; }
          }
          h2{
          font-size: 0.32rem;
          color: #2C2C2C;
          margin-bottom: 0.15rem;
          text-align: center;
        }
        .article-date{
          font-size: 0.18rem;
          color: #989898;
          margin-bottom: 0.2rem;
          text-align: center;
        }
        .article-img{
          width: 100%;
          max-height: 4rem;
          object-fit: cover;
          border-radius: 0.1rem;
          margin-bottom: 0.2rem;
        }
        .article-desc{
          font-size: 0.2rem;
          color: #4C4B4B;
          line-height: 1.8;
        }
      }
    }
    .en-about{
      padding: 0.2rem 0.1rem;
      padding-bottom: 3rem;
      background-size: 100% 100%;
      background-position: center;
      .breadcrumb{
        font-size: 0.2rem;
        color: #666;
        padding-bottom: 0.2rem;
        .breadcrumb-link{
          cursor: pointer;
          &:hover{ color: #369BF8; }
        }
      }
      .about-title{
        font-size: 0.3rem;
        color: #115DB2;
        text-align: center;
        margin: 0.2rem 0 0.5rem 0;
      }
      .about-content{
        padding: 0.3rem;
        font-size: 0.2rem;
        color: #333;
        line-height: 2;
        p{
          text-indent: 2em;
          margin: 0 0 0.15rem;
        }
      }
    }
    .en-scenery{
      padding: 0.2rem 0.1rem;
      .breadcrumb{
        font-size: 0.2rem;
        color: #666;
        padding-bottom: 0.2rem;
        .breadcrumb-link{
          cursor: pointer;
          &:hover{ color: #369BF8; }
        }
      }
      .nav-icons{
        display: flex;
        justify-content: center;
        gap: 0.3rem;
        padding: 0.3rem 0;
        background: url('../assets/imgs/图层 1054.png') no-repeat center / cover;
        .nav-item{
          position: relative;
          cursor: pointer;
          .nav-img{
            width: 2rem;
            height: 2.16rem;
            display: block;
          }
          .nav-text{
            position: absolute;
            left: 50%;
            bottom: 0.26rem;
            transform: translateX(-50%);
            font-size: 0.2rem;
            white-space: nowrap;
          }
          .nav-arrow{
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 0.08rem solid transparent;
            border-right: 0.08rem solid transparent;
            border-bottom: 0.1rem solid;
          }
        }
      }
      .content-grid{
        display: flex;
        flex-wrap: wrap;
        padding: 0.3rem 0.6rem;
        gap: 0.2rem;
        .grid-item{
          width: calc((100% - 0.4rem) / 3);
          border: 1px solid #eee;
          padding: 0.15rem;
          box-sizing: border-box;
          cursor: pointer;
          .grid-img{
            width: 100%;
            height: 2.4rem;
            object-fit: cover;
            display: block;
          }
          .grid-title{
            font-size: 0.18rem;
            color: #000;
            margin-top: 0.1rem;
            display: flex;
            align-items: center;
            .title-line{
              display: inline-block;
              width: 0.04rem;
              height: 0.2rem;
              margin-right: 0.08rem;
              flex-shrink: 0;
            }
          }
          .grid-desc{
            font-size: 0.14rem;
            color: #666;
            margin-top: 0.05rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .pagination{
        display: flex; align-items: center; justify-content: center; gap: 0.08rem; margin-top: 0.3rem; flex-wrap: wrap;
        .page-btn, .page-num{
          padding: 0.08rem 0.15rem; border: 1px solid #ddd; border-radius: 0.04rem; font-size: 0.18rem; color: #333; cursor: pointer;
          &:hover{ background: #369BF8; color: #fff; border-color: #369BF8; }
        }
        .page-num.active{ background: #369BF8; color: #fff; border-color: #369BF8; }
        .page-ellipsis{ padding: 0.08rem 0.05rem; font-size: 0.18rem; color: #666; }
        .page-info{ font-size: 0.16rem; color: #999; margin-left: 0.1rem; }
        .page-jump{
          font-size: 0.16rem; color: #666;
          .jump-input{ width: 0.5rem; height: 0.32rem; border: 1px solid #ccc; border-radius: 0.04rem; text-align: center; margin: 0 0.05rem; outline: none; }
          .jump-btn{ padding: 0.04rem 0.1rem; border: 1px solid #ddd; border-radius: 0.04rem; cursor: pointer; &:hover{ background: #369BF8; color: #fff; } }
        }
      }
      .location-content{
        padding: 0.3rem 0.6rem;
        .location-title{
          font-size: 0.28rem;
          color: #000;
          font-weight: bold;
          text-align: center;
          margin-bottom: 0.2rem;
        }
        .location-desc{
          font-size: 0.2rem;
          color: #333;
          line-height: 1.8;
          text-indent: 2em;
          margin-bottom: 0.3rem;
        }
        .location-info{
          display: flex;
          flex-direction: column;
          gap: 0.2rem;
          margin-bottom: 0.3rem;
          .info-item{
            display: flex;
            align-items: center;
            font-size: 0.2rem;
            color: #333;
            .info-icon{
              width: 0.3rem;
              height: auto;
              margin-right: 0.15rem;
              flex-shrink: 0;
            }
          }
        }
        .map-wrap{
          width: 100%;
          margin-top: 0.3rem;
          .map-img{
            width: 100%;
            height: 6rem;
            border-radius: 0.1rem;
            display: block;
          }
        }
      }
    }
    .en-service{
      padding: 0.2rem 0.1rem;
      .breadcrumb{
        font-size: 0.2rem;
        color: #666;
        padding-bottom: 0.2rem;
        .breadcrumb-link{
          cursor: pointer;
          &:hover{ color: #369BF8; }
        }
      }
      .service-title{
        font-size: 0.32rem;
        color: #333333;
        text-align: center;
        margin: 0.2rem 0 0.5rem 0;
      }
      .service-form{
        max-width: 8rem;
        margin: 0 auto;
        .form-item{
          display: flex;
          align-items: flex-start;
          margin-bottom: 0.3rem;
          .form-label{
            width: 2.5rem;
            font-size: 0.2rem;
            color: #333;
            text-align: right;
            margin-right: 0.2rem;
            padding-top: 0.15rem;
            flex-shrink: 0;
          }
          .form-input{
            flex: 1;
            height: 0.55rem;
            border: 1px solid #ccc;
            border-radius: 0.06rem;
            padding: 0 0.15rem;
            font-size: 0.18rem;
            outline: none;
            &:focus{ border-color: #369BF8; }
          }
          .form-textarea{
            flex: 1;
            height: 1.5rem;
            border: 1px solid #ccc;
            border-radius: 0.06rem;
            padding: 0.15rem;
            font-size: 0.18rem;
            outline: none;
            resize: vertical;
            font-family: inherit;
            &:focus{ border-color: #369BF8; }
          }
          .upload-area{
            flex: 1;
            display: flex;
            align-items: center;
            gap: 0.2rem;
            .upload-input{ display: none; }
            .upload-label{
              padding: 0.12rem 0.3rem;
              background: #369BF8;
              color: #fff;
              border-radius: 0.06rem;
              font-size: 0.18rem;
              cursor: pointer;
              &:hover{ background: #1372C9; }
            }
            .file-name{
              font-size: 0.16rem;
              color: #666;
            }
          }
        }
        .form-submit{
          width: 3rem;
          height: 0.6rem;
          line-height: 0.6rem;
          text-align: center;
          background: #369BF8;
          color: #fff;
          font-size: 0.22rem;
          border-radius: 0.08rem;
          cursor: pointer;
          margin: 0.5rem auto 0;
          &:hover{ background: #1372C9; }
        }
        .faq-answer{
          margin-top: 0.3rem;
          padding: 0.2rem;
          background: #F5F7FA;
          border-radius: 0.1rem;
          font-size: 0.2rem;
          color: #333;
          line-height: 1.8;
        }
      }
    }
    .en-audio, .en-vr{
      padding: 0.5rem 0.2rem;
      h1{
        font-size: 0.4rem;
        color: #005196;
        margin-bottom: 0.3rem;
      }
      h2{
        font-size: 0.32rem;
        color: #005196;
        margin-bottom: 0.2rem;
      }
      p{
        font-size: 0.2rem;
        color: #333;
        line-height: 1.8;
      }
    }
  }
}

@keyframes marquee{
  0%{ transform: translateX(0); }
  100%{ transform: translateX(-100%); }
}

@keyframes typing{
  0%, 60%, 100%{ opacity: 0.3; transform: scale(0.8); }
  30%{ opacity: 1; transform: scale(1); }
}
</style>
